import { motion } from "framer-motion";
import { ParallaxImage } from "./ParallaxImage";
import { Reveal, EASE } from "./Reveal";
import { useLang } from "../i18n";

export const SIGNATURE = {
  images: {
    luce: "arte-infissi/images/70158279-a621-4a15-992b-9fd4b8924781.webp",
    materia: "arte-infissi/images/89efcf5d-4e3c-4666-b361-8383cc4cbac5.webp",
    silenzio: "arte-infissi/images/49ab2bb0-a332-46a4-989d-3bdd713beda1.webp",
  },
  panels: {
    it: [
      ["Luce.", "Il mare entra in casa attraverso un vetro senza cornice."],
      ["Materia.", "Alluminio lavorato con precisione, per durare in silenzio."],
      ["Silenzio.", "Una villa al tramonto, protetta senza essere chiusa."],
    ],
    en: [
      ["Light.", "The sea enters the home through frameless glass."],
      ["Matter.", "Aluminium worked with precision, built to last quietly."],
      ["Silence.", "A villa at sunset, sheltered without being closed."],
    ],
  },
};

export default function Signature() {
  const { lang } = useLang();
  const keys = ["luce", "materia", "silenzio"];
  const panels = SIGNATURE.panels[lang];
  return (
    <section data-testid="signature-section" className="border-t border-[#1C1A17] bg-[#060606]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 sm:pt-36">
        <Reveal>
          <h2 data-testid="signature-title" className="font-serif font-light tracking-tight leading-[0.95] text-[#F3EFE6] text-5xl sm:text-6xl lg:text-8xl">
            Luce. <span className="italic text-[#C8A86B]">Materia.</span> Silenzio.
          </h2>
        </Reveal>
      </div>
      <div className="mt-16 sm:mt-24 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1C1A17]">
        {keys.map((k, i) => (
          <motion.div
            key={k}
            data-testid={`signature-panel-${k}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1.1, delay: i * 0.18, ease: EASE }}
            className="group relative isolate h-[70svh] min-h-[480px] md:h-[90svh] overflow-hidden bg-[#080808]"
          >
            <ParallaxImage src={SIGNATURE.images[k]} alt={panels[i][0]} className="absolute inset-0 -z-10 transition-[filter] duration-700 group-hover:brightness-110" strength={6} sizes="(max-width: 768px) 100vw, 34vw" />
            <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#080808] via-[#080808]/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-8 sm:p-10">
              <span className="font-mono text-xs tracking-[0.3em] text-[#C8A86B]">0{i + 1}</span>
              <h3 className="mt-4 font-serif text-4xl sm:text-5xl font-light text-[#F3EFE6]">{panels[i][0]}</h3>
              <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-[#D6D1C6]">{panels[i][1]}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
